import React from "react";
import { Link } from "react-router-dom";

import { viewerIcon, buttonTarget } from "../../services/viewers";

import BackButton from "./BackButton";

import ViewerStyle from '../../css/Viewer.module.css';

export default function MenuOtros(props) {
    const { othersViewers, handleShowOthersViewers, handleButtonClick, activeMenuButton, dataViewers } = props;

    // A Personas viewer is reached through its counterpart's tabs, so only the
    // other viewers get a button. One without a population gets its own.
    const renderOthersViewers = othersViewers.filter(viewer => viewer.population !== 'people').map((viewer) => {
        const target = buttonTarget(viewer, dataViewers);
        const index = dataViewers.indexOf(target);
        const isActive = activeMenuButton === viewer.id;
        const label = viewer.label.includes('Hogares') ? viewer.label.replace(' Hogares', '') : viewer.label;

        return (
            <Link key={viewer.id}
                to={`/visor-rpd/${target.slug}`}
                title={label}
                className={`${ViewerStyle["btn-month"]}${isActive ? ` ${ViewerStyle["active"]}` : ''}`}
                onClick={() => handleButtonClick(viewer.id, index)}>
                <ion-icon name={viewerIcon(viewer)}></ion-icon>
                <span>{label}</span>
            </Link>
        );
    });

    return (
        <>
            <BackButton onClick={handleShowOthersViewers} />
            {renderOthersViewers}
        </>
    );
}